import { get, last, compact } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { getPricesByHierarchyLevel, getSelectedRealEstate } from '../selectors.js';

export const getPriceTrendAPIUrl = (state) => state.config.priceTrendAPIUrl || '';

export const getGeoAutocompleteAPIUrl = (state) => state.config.geoAutocompleteAPI;

export const getSavedSearchesAPIUrl = (state) => state.config.savedSearchesApiUrl;

export const getComingSoonDetailsUrl = (state) => state.config.comingSoonDetailsUrl;

export const getTopLevelDomain = (state) => state.config.topLevelDomain;

export const getComingSoonContactEmailUrl = (state) => state.config.comingSoonContactEmailUrl;

export const getDidCompleteSurvey = (state) => state.myProperty.didCompleteSurvey;

export const getDesiredPrice = (state) => state.myProperty.desiredPrice;

export const getPricesPerQ = (state) => {
  const { myProperty } = state;
  const hierarchyLevel = 'address';
  if (!myProperty.priceTrend) {
    return { nativeData: [], parentData: [] };
  }
  const { nativeData, parentData } = getPricesByHierarchyLevel(myProperty.priceTrend, hierarchyLevel);
  return {
    nativeData: get(nativeData, 'pricesPerQ', []),
    parentData: get(parentData, 'pricesPerQ', []),
  };
};

export const getPricesPerYear = (state) => {
  const { myProperty } = state;
  const hierarchyLevel = 'address';
  if (!myProperty.priceTrend) {
    return { nativeData: [], parentData: [] };
  }
  const { nativeData, parentData } = getPricesByHierarchyLevel(myProperty.priceTrend, hierarchyLevel);
  return {
    nativeData: get(nativeData, 'prices', []),
    parentData: get(parentData, 'prices', []),
  };
};

export const getSelectedLocationName = createSelector([getSelectedRealEstate], (selectedRealEstate) => {
  const street = get(selectedRealEstate, ['address', 'street']);
  const houseNumber = get(selectedRealEstate, ['address', 'houseNumber']);
  return `${street} ${houseNumber}`;
});

export const getSelectedParentLocationName = createSelector([getSelectedRealEstate], (selectedRealEstate) =>
  get(selectedRealEstate, ['address', 'city'], ''),
);

export const getSelectedRealEstateType = createSelector([getSelectedRealEstate], (selectedRealEstate) =>
  get(selectedRealEstate, ['realEstateType'], ''),
);

export const getSelectedGeoId = createSelector([getSelectedRealEstate], (selectedRealEstate) => {
  const geoHierarchy = get(selectedRealEstate, ['address', 'geoHierarchy']);
  return last(
    compact([
      get(geoHierarchy, ['region', 'fullGeoCodeId']),
      get(geoHierarchy, ['city', 'fullGeoCodeId']),
      get(geoHierarchy, ['district', 'fullGeoCodeId']),
    ]),
  );
});
